import i18next from 'i18next';
import React from 'react';

import { Tags } from '@commons/Tags';
import Text from '@commons/Text';

export const getColumns = (clientStoreNamePlural) => [
  {
    id: 'name',
    propertyKey: 'name',
    name: i18next.t('GENERAL.NAME'),
    render: (item) => <Text>{item}</Text>,
  },
  {
    id: 'groups',
    propertyKey: 'groups',
    name: i18next.t('GENERAL.GROUPS'),
    render: (groups) => <Tags items={groups.map(({ name }) => name)} />,
  },
  {
    id: 'associatedStoresCount',
    propertyKey: 'associatedStoresCount',
    name: i18next.t('ADMIN.CENTRAL_PRODUCTS.ASSOCIATED_CENTRAL_KITCHEN_STORES_COUNT_COLUMN', {
      storeName: clientStoreNamePlural,
    }),
    excludeFromSearch: true,
    render: (item) => <Text>{item}</Text>,
  },
];

export default { getColumns };
